import PropTypes from "prop-types";
import {
  Popover,
  MenuItem,
  MenuList,
  ListItemText,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useAppStore from "@stores/client/useAppStore";

export const ToolboxPopover = (props) => {
  const { anchorEl, onClose, open = false, ...other } = props;
  const navigate = useNavigate();

  const { apps } = useAppStore();

  const handleAppClick = (appId) => {
    navigate(`/apps/${appId}`);
    onClose?.();
  };

  if (!apps || apps.length === 0) {
    return null;
  }

  return (
    <Popover
      data-testid="toolbox-popover"
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
      disableScrollLock
      disableAutoFocus
      disableEnforceFocus
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      onClose={onClose}
      open={open}
      slotProps={{
        paper: { sx: { maxWidth: 200, paddingBottom: 1 } },
      }}
      {...other}
    >
      <Box sx={{ p: 1 }}>
        {apps.map((category, index) => (
          <Box key={category.id}>
            {index > 0 && <Divider sx={{ mt: 1 }} />}
            <Typography
              variant="overline"
              // overline's default line-height (~2.66) spaces a wrapped long
              // category name like separate headings; keep it one block title.
              sx={{ px: 1, pt: 1, pb: 0.5, display: "block", color: "text.secondary", lineHeight: 1.4 }}
            >
              {category.name}
            </Typography>
            <MenuList disablePadding>
              {category.children?.map((app) => (
                <MenuItem onClick={() => handleAppClick(app.id)} key={app.id}>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle2">{app.name}</Typography>
                    }
                  />
                </MenuItem>
              ))}
            </MenuList>
          </Box>
        ))}
      </Box>
    </Popover>
  );
};

ToolboxPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
